// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3SMXT","sendOtp":"AuthorizeToLogin_sendOtp__Rf7Ij"};